var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4 64C21.5513 64 20.7374 63.6629 20.1373 63.0627C19.5371 62.4626 19.2 61.6487 19.2 60.8V51.2H6.4C4.70261 51.2 3.07475 50.5257 1.87452 49.3255C0.674284 48.1253 0 46.4974 0 44.8V6.4C0 4.70261 0.674284 3.07475 1.87452 1.87452C3.07475 0.674284 4.70261 0 6.4 0H57.6C59.2974 0 60.9253 0.674284 62.1255 1.87452C63.3257 3.07475 64 4.70261 64 6.4V44.8C64 46.4974 63.3257 48.1253 62.1255 49.3255C60.9253 50.5257 59.2974 51.2 57.6 51.2H38.08L26.24 63.072C25.6 63.68 24.8 64 24 64H22.4ZM44.8 38.4V35.2C44.8 30.944 36.256 28.8 32 28.8C27.744 28.8 19.2 30.944 19.2 35.2V38.4H44.8ZM32 12.8C30.3026 12.8 28.6748 13.4743 27.4745 14.6745C26.2743 15.8747 25.6 17.5026 25.6 19.2C25.6 20.8974 26.2743 22.5252 27.4745 23.7255C28.6748 24.9257 30.3026 25.6 32 25.6C33.6974 25.6 35.3252 24.9257 36.5255 23.7255C37.7257 22.5252 38.4 20.8974 38.4 19.2C38.4 17.5026 37.7257 15.8747 36.5255 14.6745C35.3252 13.4743 33.6974 12.8 32 12.8Z",
    fill: "url(#paint0_linear_2401_25350)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2401_25350",
    x1: 57,
    y1: -9,
    x2: 16.5,
    y2: 70,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5AB2AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFA73F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.92b446c8a871090eeecb3882ebcb7a21.svg";
export { ForwardRef as ReactComponent };